import React, { useEffect, useState } from "react";
import "./registrationDetails.css";
import { getRegisteredUsersDetails } from "../../services/master.service";

const RegistrationDetailsComponent = () => {
  const [registeredUsersDetails, setRegisteredUsersDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const activeRegisteredUsersDetails = await getRegisteredUsersDetails();
  
        if (activeRegisteredUsersDetails?.length > 0) {
          const subscribed = activeRegisteredUsersDetails.filter(
            user => user.isSubscribed === 'Y'
          );
          const unsubscribed = activeRegisteredUsersDetails.filter(
            user => user.isSubscribed !== 'Y'
          );
  
          const sortByMembershipNo = (a, b) => {
            const numA = parseInt(a.membershipNo?.match(/\d+/)?.[0] || "0", 10);
            const numB = parseInt(b.membershipNo?.match(/\d+/)?.[0] || "0", 10);
            return numA - numB;
          };
  
          subscribed.sort(sortByMembershipNo);
          unsubscribed.sort(sortByMembershipNo);
          setRegisteredUsersDetails([...subscribed, ...unsubscribed]);
        } else {
          setRegisteredUsersDetails([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setRegisteredUsersDetails([]);
      }
    };
  
    fetchData();
  }, []);

  
  const totalPages = Math.ceil(registeredUsersDetails.length / pageSize);
  const currentData = registeredUsersDetails.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const changePage = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };
  
  const renderDesktopTable = () => (
    <div className="table-responsive">
      <table className="desktop-table">
        <thead>
          <tr>
            <th className="masterHeader">SN</th>
            <th className="masterHeader">Name</th>
            <th className="masterHeader">Mobile</th>
            <th className="masterHeader">Email</th>
            <th className="masterHeader">Subscription</th>
          </tr>
        </thead>
        <tbody>
          {currentData?.map((user, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{user.name}</td>
              <td>{user.phone}</td>
              <td>{user.email}</td>
              <td>
                <span className={`status-indicator ${user.isSubscribed === 'Y' ? 'status-active' : 'status-inactive'}`}>
                  {user.isSubscribed === 'Y' ? 'Active' : 'Inactive'}
                </span>
                {user.isSubscribed === 'Y' && (
              <>
                <br />
                <span className="" style={{color:'#c916dc', paddingLeft:'10px'}}>{user.membershipName || ""}</span>
                <br />
                <span className="data-subscription">{user.membershipNo || ""}</span>
              </>
            )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        <div className="d-none d-md-flex justify-content-between align-items-center mt-3 px-2 mb-2">
          <span className="text-muted">
            Page {currentPage} of {totalPages}
          </span>
          <nav>
            <ul className="pagination mb-0">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => changePage(currentPage - 1)}>
                  Previous
                </button>
              </li>

              {/* Page numbers with ellipses */}
              {Array.from({ length: totalPages }, (_, i) => {
                const page = i + 1;

                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                      <button className="page-link" onClick={() => changePage(page)}>
                        {page}
                      </button>
                    </li>
                  );
                }

                if (
                  (page === currentPage - 2 && page !== 2) ||
                  (page === currentPage + 2 && page !== totalPages - 1)
                ) {
                  return (
                    <li key={page} className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }

                return null;
              })}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => changePage(currentPage + 1)}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
    </div>
  );

  const renderMobileCards = () => (
    <div className="mobile-cards">
      {registeredUsersDetails?.map((user, index) => (
        <div className="user-card" key={index}>
          <div className="card-row">
            <div className="card-label">Name</div>
            <div className="card-value">{user.name}</div>
          </div>
          <div className="card-row">
            <div className="card-label">Mobile</div>
            <div className="card-value">{user.phone}</div>
          </div>
          <div className="card-row">
            <div className="card-label">Email</div>
            <div className="card-value">{user.email}</div>
          </div>
          <div className="card-row">
            <div className="card-label">Subscription</div>
            <div className="card-value">
              <span style={{marginLeft:'20px!important'}} className={`status-indicator ${user.isSubscribed === 'Y' ? 'status-active' : 'status-inactive'}`}>
                {user.isSubscribed === 'Y' ? 'Active' : 'Inactive'}
              </span>
              {user.isSubscribed === 'Y' && (
              <>
                <br />
                <span className="data-subscription">{user.membershipName}</span>
                <br />
                <span className="data-subscription">{user.membershipNo}</span>
              </>
            )}
             </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="table-wrap container">
      <main>
      <div className="subscription-title mb-4">
        <h1>Registration Details</h1>
      </div>
    
        <div className="data-container">
          {registeredUsersDetails === null ? (
            <div className="no-data">Loading data...</div>
          ) : registeredUsersDetails?.length > 0 ? (
            <>
              {renderDesktopTable()}
              {renderMobileCards()}
            </>
          ) : (
            <div className="no-data">No registration data available</div>
          )}
        </div>
      </main>
    </div>
  );
};

export default RegistrationDetailsComponent;